import ConfigurableUrl from '@engine/features/configurable_urls';
import PaymentTransaction from '@engine/features/payment_transaction';
import WpfLocaleText from '@engine/features/merchant/merchant_wpf_locale_texts';
var CONFIRMABLES = {
  ConfigurableUrl: ConfigurableUrl,
  PaymentTransaction: PaymentTransaction,
  WpfLocaleText: WpfLocaleText
};

function confirmationModal() {
  var buttonTo = $('#confirmation-modal .button_to');
  var confirmModal = $('#confirmation-modal');
  var params = {};

  function isRemoteAction() {
    return params.data.confirmationRemote === true;
  }

  function callRemoteAction() {
    var actionChain = params.data.action.split('.');
    var method = null;
    actionChain.forEach(function (action, index) {
      if (method) {
        method = method[action];
      } else {
        method = CONFIRMABLES[action];
      }

      if (index === actionChain.length - 1) {
        method(params);
      }
    });
  }

  function displayModalMessage() {
    var message = params.data.name;

    if (message) {
      $('.confirmation-content').append('<span id="data-span"><strong> ' + message + '</strong>.</span>');
    } else {
      $('.modal-body').hide();
    }
  }

  function setSharedParams(e) {
    var target = $(e.relatedTarget);
    params.targetId = target.attr('id');
    params.data = target.data();
  }

  function configurateModalForm() {
    var data = params.data;
    buttonTo.attr('action', data.href);
    buttonTo.data('id', data.id);
    buttonTo.append('<input type="hidden" name="_method" value="' + data.request + '">');
  }

  confirmModal.on('show.bs.modal', function (e) {
    setSharedParams(e);
    configurateModalForm();
    displayModalMessage();
  });
  buttonTo.on('submit', function (e) {
    if (isRemoteAction()) {
      e.preventDefault();
      callRemoteAction();
    }

    confirmModal.modal('hide');
  });
  confirmModal.on('hidden.bs.modal', function () {
    $('#data-span').remove();
    $('#confirmation-modal input[name="_method"]').remove();
    buttonTo.removeAttr('action');
  });
}

export { confirmationModal };